<section class="section-inset-y">
  <div class="container">
    <h1 class="h2">{{ 'ziektebeelden-overzicht-titel' | fromDictionary }}</h1>
    <p class="text-max-width-xs">
      {{ 'ziektebeelden-overzicht-intro-tekst' | fromDictionary }}
    </p>

    <app-search-field
      class="d-block mt-5 bg-blob bg-blob--overview"
      [type]="'secondary'"
      (searchInput)="handleSearchInput($event)"
      [value]="page$().query"
    ></app-search-field>

    <!-- ! als er geen zoekveld is, dan graag deze classes op de ul.row: bg-blob bg-blob--overview -->
    <ul class="row mt-3 mt-sm-5 mt-md-8">
      @if (searchString) {
        <strong class="col-12 mb-2">Zoekresultaten ({{ profiles$().length || 0 }})</strong>
      }
      @for (item of profiles$(); track item.id) {
        <li class="col-sm-6 mb-2 col-lg-4 d-flex">
          <app-card
            [title]="item.name"
            [subTitle]="item?.category?.name"
            [label]="!item.publish ? ('ziekten-overzicht-publicatie-uit-label' | fromDictionary) : undefined"
            [link]="
              !item.publish
                ? ['/', 'pagina', '52', 'Geen-informatie']
                : ['/', 'stofwisselingsziekten', `${item.id}`, item.name| urlRewrite]
            "
          ></app-card>
        </li>
      }
      @if (!profiles$().length) {
        <li class="col-12 col-sm-6">
          <div class="empty-state">
            {{ 'zoek-categorie-profiles-niet-gevonden' | fromDictionary }}
          </div>
        </li>
      }
    </ul>

    <app-pagination [pages]="pages$()" [page]="page$()"></app-pagination>
  </div>
</section>
